const Style = {
    setupProject: 'w-full',
};

export default Style;
